import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { GuestReservations } from 'src/providers/guest-reservations/guest-reservations';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
  selector: 'tidy-restocking-integration-selector',
  templateUrl: './restocking-integration-selector.component.html',
  styleUrls: ['./restocking-integration-selector.component.scss'],
  standalone: false
})

export class RestockingIntegrationSelectorComponent implements OnInit, OnChanges {

  @Input() label = 'Where to Order';
  @Input() form: FormControl;
  @Input() submitted = false;
  @Input() errorMessage = '';
  restockingIntegrationItems: any[] = [];
  selectedValue = '';
  selectedItem: any = null;
  showOtherInput = false;
  otherValue = '';

  constructor(
    private guestReservations: GuestReservations,
    private navCtrl: CustomNavController,
    private router: Router
  ) {}

  async ngOnInit() {
    if (this.form && this.form.value) {
      this.selectedValue = this.form.value;
      this.otherValue = this.form.value;
    }
    await this.loadIntegrations();
    if (this.selectedValue && this.restockingIntegrationItems.length > 0) {
      this.selectedItem = this.restockingIntegrationItems.find(item => item.value === this.selectedValue);
    }
    console.log(this.restockingIntegrationItems)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.form && !changes.form.firstChange) {
      const newValue = changes.form.currentValue?.value;
      if (newValue && this.restockingIntegrationItems.length > 0) {
        this.selectedValue = newValue;
        this.selectedItem = this.restockingIntegrationItems.find(item => item.value === newValue);
      }
    }
  }

  async loadIntegrations() {
    try {
      const allTypes = await this.guestReservations.getSourceTypes();
      const restockingTypes = allTypes.filter(type => {
        const typeWithDetails = type as any;
        return typeWithDetails.active_details?.some(
          (detail: any) => detail.key === 'category' && detail.value === 'Restocking'
        );
      });
      const userSources = await this.guestReservations.getReservationSource();
      const activeRestockingSources = userSources.filter(source => {
        const sourceTypeId = source.guest_reservation_source_type?.id;
        const isRestockingType = restockingTypes.some(
          type => type.id === sourceTypeId
        );
        return isRestockingType && source.state !== 'paused';
      });
      const availableRestockingTypes = restockingTypes.filter(type => {
        const alreadyActive = userSources.some(
          source => source.guest_reservation_source_type?.id === type.id && 
                   source.state !== 'paused'
        );
        return !alreadyActive;
      });
      this.buildSelectItems(activeRestockingSources, availableRestockingTypes);
    } catch (error) {
      this.restockingIntegrationItems = [{
        viewValue: 'Other',
        value: 'other'
      }];
    }
  }

  buildSelectItems(activeSources: any[], availableTypes: any[]) {
    this.restockingIntegrationItems = [];
    if (activeSources.length > 0) {
      activeSources.forEach(source => {
        this.restockingIntegrationItems.push({
          viewValue: source.guest_reservation_source_type?.name || 'Integration',
          value: `integration:${source.id}`,
          icon: source.guest_reservation_source_type?.logo_url
        });
      });
    }
    if (availableTypes.length > 0) {
      availableTypes.forEach(type => {
        this.restockingIntegrationItems.push({
          viewValue: `Add ${type.name}`,
          value: `add:${type.id}`,
          icon: type.logo_url
        });
      });
    }
    this.restockingIntegrationItems.push({
      viewValue: 'Other',
      value: 'other'
    });
    this.parseCurrentValue(activeSources);
  }

  parseCurrentValue(activeSources: any[]) {
    const currentValue = this.form?.value;
    if (!currentValue) {return;}
    if (currentValue.startsWith('integration:')) {
      this.selectedValue = currentValue;
      this.selectedItem = this.restockingIntegrationItems.find(item => item.value === currentValue);
      return;
    }
    const sourceId = parseInt(currentValue);
    if (!isNaN(sourceId)) {
      const matchingSource = activeSources.find(s => s.id === sourceId);
      if (matchingSource) {
        this.selectedValue = `integration:${sourceId}`;
        this.form.setValue(`integration:${sourceId}`);
        this.selectedItem = this.restockingIntegrationItems.find(item => item.value === `integration:${sourceId}`);
        return;
      }
    }
    this.otherValue = currentValue;
    this.selectedValue = 'other';
    this.showOtherInput = true;
  }

  onSelectionChange(value: string) {
    if (!value) {return;}
    this.selectedItem = this.restockingIntegrationItems.find(item => item.value === value);
    if (value === 'other') {
      this.showOtherInput = true;
      this.selectedValue = 'other';
      if (!this.otherValue && this.form?.value && !this.form.value.startsWith('integration:')) {
        this.otherValue = this.form.value;
      }
    } else if (value.startsWith('add:')) {
      const typeId = value.replace('add:', '');
      this.guestReservations.getSourceTypes().then(types => {
        const type = types.find(t => t.id.toString() === typeId);
        if (type) {
          const params = {
            reservationSrcType: {
              name: type.name,
              id: type.id,
              logo_url: type.logo_url,
              formats: [type.format]
            },
            sourceType: type.format,
            returnUrl: this.router.url
          };
          this.navCtrl.navigateForward('integration/add-integration', params);
        }
      });
    } else if (value.startsWith('integration:')) {
      this.showOtherInput = false;
      this.otherValue = '';
      this.selectedValue = value;
      this.form.setValue(value);
    }
  }

  onOtherInputChange(value: string) {
    this.otherValue = value;
    this.form.setValue(value);
  }

}